import React from 'react';
import PropTypes from 'prop-types';
import Question from '../../common/Question';
import TextAreaInput from '../../common/TextAreaInput';
import YesNoInputGroup from '../../common/YesNoInputGroup';
import './ExpertiseTab.scss';
var isDescEmpty = function isDescEmpty(desc) {
  return !desc || !desc.trim();
};
var isDescTooShort = function isDescTooShort(desc) {
  return !desc || desc.replaceAll(/ /g, '').length < 50;
};
var exampleText = {
  therapeutic_areas: {
    positive: 'While at Genzyme worked on Endocrine Ph III study and at Cubist worked on Ph I Metabolism study.',
    negative: 'I do not have experience in cardiology but have worked with Class III devices in the pulmonary/respiratory space.'
  },
  disease_codes: {
    positive: 'I designed a Phase II protocol for triple negative breast cancer while at Roche.',
    negative: "I have not worked with sickle cell anemia specifically but have a strong understanding of blood diseases\nand immune-mediated hematological disorders, as I worked for Celgene."
  },
  regulatory_pathways: {
    positive: 'I have worked on 10+ IND studies and 4 BLA studies throughout my career across a range of disease areas.',
    negative: 'I have supported clinical trials from phase 2b and 3 as well as post marketing but have not been directly involved with writing INDs.'
  },
  therapies: {
    positive: 'I have held several CMC positions for small molecules at Pfizer and J&J.',
    negative: 'I do not have experience in In Vitro Diagnostics using biological samples. I do have experience developing micro-electronics for biotech applications.'
  },
  about: "[Project role] with [#] years of experience working for [small/medium/large/enterprise \nbiotechnology/pharmaceutical/medical device/CRO] companies. With [list your top accomplishments] and expertise in \n[list Therapeutic Area(s) and/or Product Technologies/Modalities needed for the project that match your background], \nI am very interested in this project. Based on my experience, I believe that I would be a terrific fit."
};
var renderRequired = function renderRequired(render) {
  if (render) {
    return /*#__PURE__*/React.createElement("div", {
      className: "body-text-2 medium-weight with-error-text mb-2"
    }, /*#__PURE__*/React.createElement("i", {
      className: "fa fa-exclamation-triangle"
    }), ' ', "Required!");
  }
  return null;
};
function ExpertiseTab(_ref) {
  var project = _ref.project,
    proposal = _ref.proposal,
    onFormChange = _ref.onFormChange,
    errors = _ref.errors,
    screeningAnswers = _ref.screeningAnswers;
  var numberIndexes = ['1. ', '2. ', '3. '];
  var letterIndexes = ['a. ', 'b. ', 'c. ', 'd. ', 'e. ', 'f. '];
  var tagTypes = ['therapeutic_areas', 'disease_codes', 'regulatory_pathways', 'therapies'];
  var tagHeadings = {
    therapeutic_areas: 'Therapeutic Areas',
    disease_codes: 'Diseases & Indications',
    regulatory_pathways: 'Regulatory Pathways',
    therapies: 'Product Technologies'
  };
  var displayExperienceQuestion = tagTypes.reduce(function (aggr, tagType) {
    return aggr || project[tagType].length !== 0;
  }, false);
  var displayedErrors = {};
  var displayedExample = {};
  tagTypes.forEach(function (category) {
    if (isDescEmpty(proposal["".concat(category, "_desc")])) {
      displayedErrors[category] = errors["".concat(category, "_desc")];
    }
    if (proposal[category]) {
      displayedExample[category] = proposal[category].some(function (p) {
        return p.selected === 'No';
      }) ? exampleText[category].negative : exampleText[category].positive;
    }
  });
  screeningAnswers.forEach(function (answer) {
    var currentValue = proposal["screening_answer_".concat(answer.id)];
    if (isDescTooShort(currentValue)) {
      displayedErrors["screening_questions_".concat(answer.question_id)] = errors["screening_questions_".concat(answer.question_id)];
    }
  });
  if (isDescEmpty(proposal.about_consultant)) {
    displayedErrors.about_consultant = errors.about_consultant;
  }
  return /*#__PURE__*/React.createElement("div", null, screeningAnswers.length ? /*#__PURE__*/React.createElement("div", {
    className: "body-text-2 medium-weight mb-5"
  }, numberIndexes.shift(), "Your experience related to project responsibilities", /*#__PURE__*/React.createElement("ul", {
    className: "screening-questions-list"
  }, screeningAnswers.map(function (q) {
    var screeningError = displayedErrors["screening_questions_".concat(q.question_id)];
    return /*#__PURE__*/React.createElement("li", {
      key: q.id
    }, /*#__PURE__*/React.createElement(Question, {
      title: q.question_text,
      location: "proposal-edit"
    }, screeningError && /*#__PURE__*/React.createElement("div", {
      className: "body-text-2 medium-weight with-error-text mb-2"
    }, /*#__PURE__*/React.createElement("i", {
      className: "fa fa-exclamation-triangle"
    }), ' ', "Response must be at least 50 characters."), /*#__PURE__*/React.createElement(TextAreaInput, {
      className: "project-screening-question",
      formKey: "screening_answer_".concat(q.id),
      onAnswerChange: function onAnswerChange(val) {
        return onFormChange("screening_answer_".concat(q.id), val);
      },
      errors: errors,
      value: proposal["screening_answer_".concat(q.id)],
      error: screeningError,
      textPromptClass: screeningError ? 'with-error-text' : '',
      textAreaPrompt: "Minimum 50 characters."
    })));
  }))) : '', displayExperienceQuestion && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "body-text-2 medium-weight mb-5"
  }, numberIndexes.shift(), "Is your profile reflecting your experience correctly?"), tagTypes.map(function (tagType) {
    return project[tagType].length !== 0 && /*#__PURE__*/React.createElement("div", {
      key: tagType,
      className: "ms-4 mb-5"
    }, /*#__PURE__*/React.createElement(Question, {
      title: "".concat(letterIndexes.shift()).concat(tagHeadings[tagType]),
      location: "proposal-edit"
    }, /*#__PURE__*/React.createElement("div", {
      className: "ms-4 expertise-question"
    }, /*#__PURE__*/React.createElement(YesNoInputGroup, {
      options: project[tagType],
      formKey: tagType,
      value: proposal[tagType],
      onAnswerChange: function onAnswerChange(val) {
        return onFormChange(tagType, val);
      },
      errors: errors
    }), proposal[tagType] && proposal[tagType].some(function (tag) {
      return tag.selected !== null;
    }) && /*#__PURE__*/React.createElement("div", {
      className: "mt-3 ".concat(tagType.replace(/_/, '-'), "-description")
    }, renderRequired(displayedErrors[tagType]), /*#__PURE__*/React.createElement(TextAreaInput, {
      placeholder: "Type your experience here.",
      onAnswerChange: function onAnswerChange(val) {
        return onFormChange("".concat(tagType, "_desc"), val);
      },
      value: proposal["".concat(tagType, "_desc")],
      error: displayedErrors[tagType],
      exampleText: displayedExample[tagType],
      textPromptClass: displayedErrors[tagType] ? 'with-error-text' : '',
      textAreaPrompt: "Tell us specific examples of your experience as it relates to the answers above.",
      required: null
    })))));
  })));
}
ExpertiseTab.propTypes = {
  project: PropTypes.shape({}).isRequired,
  screeningAnswers: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  proposal: PropTypes.shape({}).isRequired,
  onFormChange: PropTypes.func.isRequired,
  errors: PropTypes.shape({}).isRequired
};
ExpertiseTab.defaultProps = {};
export default ExpertiseTab;